import { POPOVER_PLACEMENTS, POPOVER_TRIGGERS } from "root/libs/constants/src";

/* eslint-disable no-param-reassign */
export function assignControlsConstants(Component) {
  Component.prototype = Object.assign(Component, {
    ...POPOVER_TRIGGERS,
    ...POPOVER_PLACEMENTS,
  });
}
